import { render, staticRenderFns } from "./widgetSecAntispam.vue?vue&type=template&id=360d2f1d&scoped=true&"
import script from "./widgetSecAntispam.vue?vue&type=script&lang=js&"
export * from "./widgetSecAntispam.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecAntispam.vue?vue&type=style&index=0&id=360d2f1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d2f1d",
  null
  
)

export default component.exports